import React, { useMemo } from "react";
import { BarGraph } from "../../ui/Graph";
import PropTypes from "prop-types";

class GraphBar {
  constructor(data) {
    this.data = data;
  }

  getLabesAxisX() {
    const data = this.data;
    const labels = [...new Set(data.map((item) => item.dt_message))];

    return labels;
  }

  getLabelAxisSmsY() {
    const data = this.data;
    const sms = data.map((item) => item.i_sms);

    return sms;
  }

  getLabelAxisRcsY() {
    const data = this.data;
    const rcs = data.map((item) => item.i_rcs);

    return rcs;
  }

  getLabelAxisAmountY() {
    const data = this.data;
    const amount = data.map((item) => item.n_amount);

    return amount;
  }
}
const GraphByDayDashboard = ({ data = [], loading = false }) => {
  const { axisX, sms, amount, rcs } = useMemo(() => {
    const Resolver = new GraphBar(data);

    const labelsX = Resolver.getLabesAxisX();
    const axisSMS = Resolver.getLabelAxisSmsY();
    const axisAmount = Resolver.getLabelAxisAmountY();
    const axisRcs = Resolver.getLabelAxisRcsY()

    return {
      axisX: labelsX,
      sms: axisSMS,
      rcs: axisRcs,
      amount: axisAmount,
    };
  }, [data]);

  const dataGraph = {
    labels: axisX,
    datasets: [
      {
        type: "line",
        label: "Monto ($)",
        borderColor: "rgb(239, 68, 68)",
        backgroundColor: "rgb(239, 68, 68)",
        yAxisID: "y1",
        data: amount,
        fill: false,
        tension: 0.2,
        pointStyle: "circle",
        pointRadius: 0,
      },
      {
        type: "bar",
        label: "SMS",
        borderColor: "rgb(16, 163, 127)",
        backgroundColor: "rgb(16, 163, 127)",
        yAxisID: "y1",
        data: sms,
        fill: false,
        tension: 0.2,
        pointStyle: "circle",
        pointRadius: 0,
      },
      {
        type: "bar",
        label: "RCS",
        borderColor: "rgb(120, 40, 200)",
        backgroundColor: "rgb(120, 40, 200)",
        yAxisID: "y2",
        data: rcs,
        fill: false,
        tension: 0.2,
        pointStyle: "circle",
        pointRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    interaction: {
      mode: "index",
      intersect: false,
    },

    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#6b7280",
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        backgroundColor: "#ffffff",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        borderRadius: 8,
        titleColor: "#000000",
        bodyColor: "#000000",
        padding: 10,
        displayColors: false,
      },

      title: {
        display: false,
      },
    },

    scales: {
      x: {
        ticks: {
          color: "#6b7280",
          font: { size: 12 },
        },

        display: true,
        grid: {
          lineWidth: 0.5,
        },
      },
      // y: {
      //   type: "linear",
      //   display: true,
      //   position: "right",
      //   // Opcional: agregar configuración específica para la escala del monto
      //   title: {
      //     display: true,
      //     text: "Monto ($)",
      //     color: "#6b7280",
      //   },
      // },
      y1: {
        type: "linear",
        position: "left",
        ticks: {
          color: "#6b7280",
          font: { size: 12 },
        },
        display: true,
        grid: {
          lineWidth: 0.5,
          drawOnChartArea: false,
        },
      },
      y2: {
        type: "linear",
        position: "right",
        ticks: {
          color: "#6b7280",
          font: { size: 12 },
        },
        display: true,
        grid: {
          lineWidth: 0.5,
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
    <div className="w-full h-full">
      <div className="grid grid-cols-1 h-96">
        <BarGraph
          title="Mensajes por periodo"
          data={dataGraph}
          options={options}
          loading={loading}
          exportData={data}
        />
      </div>
    </div>
  );
};
GraphByDayDashboard.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  loading: PropTypes.bool,
};
export { GraphBar };
export default GraphByDayDashboard;
